<div class="main-container">
    <div class="main-page">
        <div class="prospect-detail">
            <div class="white-card">
                <div class="header-title-row">
                    <div class="header-left">
                        <img src="assets/svg/functions-icon.svg" alt="Funciones de contactos" class="center-svg"/>
                        <h1 class="text-semibold color-org t-24">Funciones de contactos</h1>
                    </div>
                    <div class="header-actions">
                    <div class="header-actions">
                        <button class="btn btn-round-outline"><img src="assets/svg/settings-icon.svg"/></button>
                        <button class="btn btn-round-outline"><img src="assets/svg/reload-icon-org.svg"/></button>
                        <button class="btn btn-round-outline"><img src="assets/svg/filterpng-icon.svg"/></button>
                    </div>
                        <button class="action-btn outline">
                            Modificar funciones de contactos
                        </button>
                        <button class="action-btn primary" (click)="openMdlAddFunction()">
                            Agregar funciones de contactos
                        </button>
                        
                    </div>
                </div>
                <div class="header-stats mt-3">
                    <span>{{contactos.length}} elementos | Se actualizó hace 2 minutos | Ordenado por última modificación</span>
                </div>
                <div class="content-area mt-5">
                   
                    <div class="prospectos-table mh-50">
                        <table>
                            <thead>
                                <tr>
                                    <th class="checkbox-column text-center">
                                    </th>
                                    <th>
                                        <div class="d-flex align-items-center">
                                            Nombre del contacto
                                            <img src="assets/svg/arrow-down-black.svg" width="14" class="ms-1">
                                        </div>
                                    </th>
                                    <th>
                                        <div class="d-flex align-items-center">
                                            Función
                                            <img src="assets/svg/arrow-down-black.svg" width="14" class="ms-1">
                                        </div>
                                    </th>
                                    <th>
                                        <div class="d-flex align-items-center">
                                            Cargo
                                            <img src="assets/svg/arrow-down-black.svg" width="14" class="ms-1">
                                        </div>
                                    </th>
                                    <th>
                                        <div class="d-flex align-items-center">
                                            Principal
                                            <img src="assets/svg/arrow-down-black.svg" width="14" class="ms-1">
                                        </div>
                                    </th>
                                    <th>
                                        <div class="d-flex align-items-center">
                                            Teléfono
                                            <img src="assets/svg/arrow-down-black.svg" width="14" class="ms-1">
                                        </div>
                                    </th>
                                    <th>
                                        <div class="d-flex align-items-center">
                                            Correo
                                            <img src="assets/svg/arrow-down-black.svg" width="14" class="ms-1">
                                        </div>
                                    </th>
                                    <th>
                                        <div class="d-flex align-items-center">
                                            Nombre de la cuenta
                                            <img src="assets/svg/arrow-down-black.svg" width="14" class="ms-1">
                                        </div>
                                    </th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                @for(item of contactos; track item.contacto_id){
                                    <tr>
                                        <td class="checkbox-column">
                                            <input type="checkbox">
                                        </td>
                                        <td>{{item.nombre}} {{item.apellido}}</td>
                                        <td>{{item.funcion}}</td>
                                        <td>{{item.cargo}}</td>
                                        <td>11/11/2025</td>
                                        <td>{{item.telefono}}</td>
                                        <td>{{item.email}}</td>
                                        <td>{{item.cuenta.nombre_empresa}}</td>
                                        <td class="actions-cell">
                                            <div class="dropdown-container" (click)="$event.stopPropagation()">
                                                <button class="dots-button" (click)="toggleActionsMenu('menu-' + item.contacto_id)">
                                                    <svg class="dots-icon" viewBox="0 0 24 24">
                                                        <circle cx="12" cy="5" r="2"/>
                                                        <circle cx="12" cy="12" r="2"/>
                                                        <circle cx="12" cy="19" r="2"/>
                                                    </svg>
                                                </button>
                                                <div class="dropdown-menu" [class.show]="openedMenuId === 'menu-' + item.contacto_id">
                                                    <button class="dropdown-item" (click)="updateContact(item)">Modificar</button>
                                                    <button class="dropdown-item" (click)="openMdlDeleteContact(item.contacto_id)">Eliminar</button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>        
</div>